// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/react-scripts/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img_logo_mini {
  width: 50px;
  height: 50px;
}

.navigation {
  flex-direction: row;
  row-gap: 0px;
  column-gap: 10px;
  display: flex;
}

.home_button_img {
  width: 22px;
  height: 19px;
}

.out_button_img {
  width: 14px;
  height: 22px;
}

.cancel_button {
  width: 20px;
  height: 20px;
}

.menu_button {
  display: none;
  z-index: 1003;
  position: relative;
}

.home_button, .menu_button {
  cursor: pointer;
  border: none;
  background: #222423;
  width: 50px;
  height: 50px;
  border-radius: 16px;
}

.search_container {
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

.work_panel_container {
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  position: fixed;
  top: 100px;
  z-index: 20 !important;
  justify-content: space-between;
  width: 100%;
  font-size: 16px;
}

@media (max-width: 850px) {
  .work_panel_container {
    position: static;
  }
}
select {
  background: #181A19;
  padding: 5px 10px;
  color: white;
  font-size: 16px;
  height: 100%;
  border: none;
}

.input_search {
  padding: 9px 15px;
  border-radius: 16px;
  color: white;
  font-size: 16px;
  text-align: left;
  max-width: 200px;
  background: #181A19;
  border: 2px #373A39 solid;
}
.input_search::placeholder {
  text-align: center;
}

@media (max-width: 850px) {
  .search_container {
    flex-direction: row;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
  }
}
.operation_car_container, .completed_cars_list_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

@media (max-width: 850px) {
  .operation_car_card_container {
    flex-direction: column;
    row-gap: 30px;
    column-gap: 10px;
    display: flex;
  }
}
@media (max-width: 750px) {
  .search_container {
    flex-direction: column;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
  }
  .work_panel_container {
    flex-direction: column;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
    justify-content: center;
  }
  .input_search {
    max-width: calc(100% - 30px);
  }
  .sore_container {
    max-width: calc(100% - 30px);
  }
}
.photos_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  position: relative;
  width: 300px;
}

.photo_car {
  width: 300px;
  height: 300px;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
}

.loading {
  opacity: 0.3;
}

.title_loading {
  position: absolute;
  top: 40%;
  left: 40%;
}

@media (max-width: 850px) {
  .photo_car {
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .photos_container {
    position: relative;
    width: 100%;
    padding-top: 50px;
  }
}
.operation_car_card_container, .completed_car_card_container {
  background: #222423;
  border-radius: 16px;
  padding: 35px;
  color: white;
  display: grid;
  column-gap: 50px;
  grid-template-columns: 3fr 1fr;
}

.padding {
  padding-bottom: 90px;
}

@media (max-width: 750px) {
  .information_container {
    grid-template-columns: 1fr !important;
    grid-auto-flow: row;
    grid-template-rows: auto auto auto auto !important;
    grid-template-areas: "person" "car" "status" !important;
  }
}
@media (max-width: 750px) {
  .information_container {
    align-self: center;
  }
}
@media (max-width: 850px) {
  .completed_car_card_container, .operation_car_card_container {
    display: flex !important;
    flex-direction: column;
  }
}
@media (max-width: 550px) {
  .information_container_ {
    display: flex !important;
    flex-direction: column;
  }
}
.information_container, .information_container_ {
  flex-direction: column;
  row-gap: 30px;
  column-gap: 10px;
  display: flex;
}

.information_person_container {
  grid-area: person;
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

.information_car_container {
  grid-area: car;
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

.information_car_status_container {
  grid-area: status;
}

.line {
  height: 6px;
  background: #373A39;
  border: none;
  position: relative;
  top: -6px;
  left: 0;
}

.line_progress {
  height: 6px;
  position: relative;
  z-index: 3;
  top: 0;
  left: 0;
  border: none;
  background: linear-gradient(to right, #F08319, #E51B2F);
}

.status_completed_container {
  border-radius: 16px;
  left: 0;
  border: 2px solid transparent;
  padding: 10px;
  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
}

.status_container {
  outline: none;
  position: relative;
  z-index: 3;
  top: 50px;
  border-radius: 16px;
  left: 0;
  border: 2px solid transparent;
  padding: 10px;
  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
}

@media (max-width: 1100px) {
  .status_container {
    margin-left: 0px !important;
  }
}
.status_completed {
  border-radius: 16px;
  left: 0;
  border: 2px solid transparent;
  padding: 10px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.status {
  outline: none;
  position: relative;
  z-index: 3;
  top: 0px;
  border-radius: 16px;
  left: 0;
  border: 2px solid transparent;
  padding: 10px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.circle {
  top: -31px;
  position: relative;
  background: #373A39;
  width: 15px;
  height: 15px;
  z-index: 3;
  border-radius: 50%;
}

.circle {
  position: absolute;
  top: 2px;
  background: #373A39;
  width: 15px;
  height: 15px;
  z-index: 3;
  border-radius: 50%;
  transform: translateX(-50%);
}

.circle_progress {
  background: linear-gradient(to right, #F08319, #E51B2F) !important;
}

.information_car_status_container {
  position: relative;
  height: 20px;
}

.line {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 6px;
  background: #373A39;
  width: 100%;
  border: none;
}

.line_progress {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 6px;
  z-index: 2;
  border: none;
  background: linear-gradient(to right, #F08319, #E51B2F);
}

.information_car_completed_status_container {
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  align-items: center;
}

.navigation_link {
  color: white;
  text-decoration: none;
}

.whatsapp {
  padding: 1px 3px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  background: linear-gradient(to right, #F08319, #E51B2F);
  color: white;
  transition: all 1s;
}
.whatsapp:hover {
  opacity: 0.5;
}

.info {
  display: flex;
  gap: 10px;
  align-items: center;
}

@media (max-width: 600px) {
  .info {
    align-self: flex-start;
  }
}
.change_password_container {
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
}

@media (max-width: 730px) {
  .change_password_container {
    flex-direction: column;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
  }
}
.number {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.profile_container {
  font-size: 22px;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #222423;
  border-radius: 16px;
  padding: 35px;
  color: white;
}

@media (max-width: 960px) {
  .profile_container {
    flex-direction: column;
    row-gap: 10px;
    column-gap: 10px;
    display: flex;
  }
}
.informations_person_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  font-size: 16px;
  align-self: flex-start;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1004;
}

.overlay_ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000 !important;
}

.popup_menu_container {
  flex-direction: column;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  background: #222423;
  position: fixed;
  z-index: 1002;
  right: 50px;
  top: 30px;
  bottom: 30px;
  padding: 80px 10px 10px;
  border-radius: 16px;
}

.none {
  display: none;
}

.popup_menu_link {
  padding: 5px;
  font-size: 18px;
  text-decoration: none;
  color: #b5b5b5;
  transition: all 1s;
}
.popup_menu_link:hover {
  color: #ffffff;
}

.grey_popup_menu_link {
  opacity: 0.5;
  padding: 5px;
  font-size: 18px;
  text-decoration: none;
  color: #D9D9D9;
}

.shadow_window_img_container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  padding: 10px;
  border-radius: 10px;
  z-index: 1005;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.slider {
  width: 65%;
}

@media (max-width: 1000px) {
  .slider {
    width: 85%;
  }
}
.slick-dots li button {
  display: block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #D9D9D9;
}

.slick-dots li.slick-active button {
  background: linear-gradient(to right, #F08319, #E51B2F);
  opacity: 1;
}

button::before {
  display: none;
}

.slick-prev {
  left: -50px;
}

.slick-next {
  right: -20px;
}

.save {
  width: 200px;
}

.change_password_window_container {
  flex-direction: column;
  row-gap: 20px;
  column-gap: 10px;
  display: flex;
  align-items: center;
  background: #222423;
  padding: 70px;
  border-radius: 16px;
}

@media (max-width: 600px) {
  .change_password_window_container {
    padding: 60px 50px 50px;
  }
  .sort_container {
    padding-top: 120px;
  }
}
@media (max-width: 450px) {
  .change_password_window_container {
    padding: 60px 30px 30px;
  }
}
.change_input_container {
  position: relative;
}

.cancel {
  cursor: pointer;
  width: 25px;
  position: absolute;
  right: 15px;
  top: 15px;
  transition: all 1s;
}
.cancel:hover {
  opacity: 0.5;
}

.input-container_ {
  position: relative;
}

input:focus + .placeholder_,
input:not(:placeholder-shown) + .placeholder_ {
  top: -10px;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  background: #222423;
  background: linear-gradient(to right, #F08319, #E51B2F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.placeholder_ {
  position: absolute;
  left: 10px;
  top: 18px;
  transition: all 0.3s ease;
  color: #8E8E8E;
  font-size: 18px;
  pointer-events: none;
  text-align: center;
  width: calc(100% - 20px);
  background: #222423;
  border-radius: 8px;
}

.change_input {
  padding: 10px 0px;
  text-align: center;
  border-radius: 10px;
  border: 2px solid transparent;
  font-size: 18px;
  height: 30px;
  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
  width: 600px;
  transition: all 0.3s;
  color: white;
}
.change_input:focus {
  outline: none;
  border: 2px solid transparent;
  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box;
}

@media (max-width: 800px) {
  .change_input {
    width: 400px;
  }
}
@media (max-width: 600px) {
  .change_input {
    width: 300px;
  }
}
.background_new {
  color: #222423;
  z-index: 0;
  position: absolute;
  background: #222423;
  left: 35%;
  top: -12px;
  width: 180px;
}

.background_new_ {
  color: #222423;
  z-index: 0;
  position: absolute;
  background: #222423;
  left: 34%;
  top: -12px;
  width: 190px;
}

.background_old {
  color: #222423;
  z-index: 0;
  position: absolute;
  background: #222423;
  left: 35%;
  top: -12px;
  width: 180px;
}

@media (max-width: 800px) {
  .background_old {
    left: 28%;
    width: 178px;
  }
  .background_new {
    left: 29%;
    width: 169px;
  }
  .background_new_ {
    left: 27%;
    width: 185px;
  }
}
@media (max-width: 600px) {
  .background_old {
    left: 21%;
    width: 178px;
  }
  .background_new {
    left: 22%;
    width: 169px;
  }
  .background_new_ {
    left: 20%;
    width: 185px;
  }
}
@media (max-width: 400px) {
  .background_old {
    left: 27%;
    width: 178px;
  }
  .background_new {
    left: 28%;
    width: 169px;
  }
  .background_new_ {
    left: 26%;
    width: 185px;
  }
}
@media (max-width: 1100px) {
  .navigation_link, .home_button {
    display: none;
  }
  .menu_button {
    display: block;
  }
}
.succeeded {
  background: rgba(97, 200, 98, 0.5);
  padding: 7px;
  border-radius: 10px;
  font-size: 18px;
}

.error {
  background: rgba(229, 27, 47, 0.5);
  padding: 7px;
  color: #D9D9D9;
  border-radius: 10px;
  font-size: 18px;
}

.not_found_search {
  color: white;
  display: flex;
  justify-content: center;
  font-size: 20px;
}

@media (min-width: 850px) {
  .input_desktop {
    display: none;
  }
}
@media (max-width: 850px) {
  .input_mobile {
    display: none;
  }
}
option {
  font-size: 14px;
}

select {
  font-size: 14px;
  color: #F08319;
  -webkit-tap-highlight-color: transparent;
}
select:focus-visible {
  border: none;
}

footer {
  height: 167px;
  background: #181A19;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  width: 100%;
}

header {
  background: #181A19;
  position: fixed;
  top: 0;
  z-index: 2;
  height: 50px;
  left: 0;
  right: 0;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  padding: 40px 50px;
}

.sort_container {
  font-size: 14px;
  color: #D9D9D9;
}

.not_visible {
  color: #222423;
}

@media (max-width: 850px) {
  .not_visible {
    display: none;
  }
}
@media (max-width: 600px) {
  .profile_container {
    margin-top: 140px;
  }
  .operation_work_panel_container {
    margin-top: 140px;
  }
}
@media (max-width: 750px) {
  .information_container {
    align-self: stretch;
  }
}
@media (max-width: 600px) {
  .profile_container {
    margin-top: 140px;
  }
  .operation_work_panel_container {
    margin-top: 140px;
  }
}
@media (max-width: 750px) {
  .information_container {
    align-self: stretch;
  }
}
input:focus {
  transform: scale(1);
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/components.sass"],"names":[],"mappings":"AASA;EACE,WAAA;EACA,YAAA;AANF;;AASA;EAbE,mBAc2B;EAb3B,YAagC;EAZhC,gBAYqC;EAXrC,aAAA;AAQF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAAA;EACE,WAAA;EACA,YAAA;AAGF;;AAFA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;AAKF;;AAJA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAOF;;AANA;EAnCE,mBAoC2B;EAnC3B,aAmCgC;EAlChC,gBAkCsC;EAjCtC,aAAA;AA6CF;;AANA;EA1CE,mBA2C2B;EA1C3B,aA0CgC;EAzChC,gBAyCsC;EAxCtC,aAAA;EAyCA,eAAA;EACA,UAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAYF;;AAVA;EACE;IACE,gBAAA;EAaF;AACF;AAZA;EACE,mBAAA;EACA,iBAAA;EAEA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAaF;;AANA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AASF;AARE;EACE,kBAAA;AAUJ;;AATA;EACE;IAjFA,mBAkF6B;IAjF7B,aAiFkC;IAhFlC,gBAgFwC;IA/ExC,aAAA;EA8FA;AACF;AAfA;EAnFE,sBAoF2B;EAnF3B,aAmFmC;EAlFnC,gBAkFyC;EAjFzC,aAAA;AAqGF;;AAjBA;EACE;IAxFA,sBAyF6B;IAxF7B,aAwFqC;IAvFrC,gBAuF2C;IAtF3C,aAAA;EA6GA;AACF;AAtBA;EACE;IA5FA,sBA6F6B;IA5F7B,aA4FqC;IA3FrC,gBA2F2C;IA1F3C,aAAA;EAqHA;EAzBA;IA/FA,sBAgG6B;IA/F7B,aA+FqC;IA9FrC,gBA8F2C;IA7F3C,aAAA;IA8FE,uBAAA;EA8BF;EA7BA;IACE,4BAAA;EA+BF;EA9BA;IACE,4BAAA;EAgCF;AACF;AA9BA;EAxGE,sBAyG2B;EAxG3B,aAwGmC;EAvGnC,gBAuGyC;EAtGzC,aAAA;EAuGA,kBAAA;EACA,YAAA;AAmCF;;AAlCA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAqCF;;AApCA;EACE,YAAA;AAuCF;;AAtCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAyCF;;AAxCA;EAEE;IACE,WAAA;IACA,iBAAA;IACA,uBAAA;EA0CF;EAzCA;IACE,kBAAA;IACA,WAAA;IACA,iBAAA;EA2CF;AACF;AAzCA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AA2CF;;AAzCA;EACE,oBAAA;AA4CF;;AA3CA;EACE;IACE,qCAAA;IACA,mBAAA;IACA,kDAAA;IACA,uDAAA;EA8CF;AACF;AA9CA;EACE;IACE,kBAAA;EAgDF;AACF;AA/CA;EACE;IACE,wBAAA;IACA,sBAAA;EAiDF;AACF;AAjDA;EACE;IACE,wBAAA;IACA,sBAAA;EAmDF;AACF;AAjDA;EAnKE,sBAoK2B;EAnK3B,aAmKmC;EAlKnC,gBAkKyC;EAjKzC,aAAA;AAuNF;;AApDA;EACE,iBAAA;EAvKA,sBAwK2B;EAvK3B,aAuKmC;EAtKnC,gBAsKyC;EArKzC,aAAA;AA+NF;;AAxDA;EACE,cAAA;EA3KA,sBA4K2B;EA3K3B,aA2KmC;EA1KnC,gBA0KyC;EAzKzC,aAAA;AAuOF;;AA5DA;EACE,iBAAA;AA+DF;;AA5DA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AA+DF;;AA7DA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,uDAAA;AAgEF;;AA/DA;EACE,mBAAA;EACA,OAAA;EACA,6BAAA;EACA,aAAA;EACA,mHAAA;AAkEF;;AA/DA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,OAAA;EACA,6BAAA;EACA,aAAA;EACA,mHAAA;AAkEF;;AAjEA;EACE;IACE,2BAAA;EAoEF;AACF;AAnEA;EACE,mBAAA;EACA,OAAA;EACA,6BAAA;EACA,aAAA;EACA,uDAAA;EACA,6BAAA;EACA,oCAAA;AAqEF;;AApEA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,OAAA;EACA,6BAAA;EACA,aAAA;EACA,uDAAA;EACA,6BAAA;EACA,oCAAA;AAuEF;;AArEA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAwEF;;AAtEA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;AAyEF;;AAvEA;EACE,kEAAA;AA0EF;;AAvEA;EACE,kBAAA;EACA,YAAA;AA0EF;;AAxEA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA2EF;;AAzEA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uDAAA;AA4EF;;AAzEA;EA3RE,mBA4R2B;EA3R3B,aA2RgC;EA1RhC,gBA0RsC;EAzRtC,aAAA;EA0RA,mBAAA;AA+EF;;AA5EA;EACE,YAAA;EACA,qBAAA;AA+EF;;AA7EA;EACE,gBAAA;EAGA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uDAAA;EACA,YAAA;EACA,kBAAA;AA8EF;AA7EE;EACE,YAAA;AA+EJ;;AA7EA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAgFF;;AA/EA;EACE;IACE,sBAAA;EAkFF;AACF;AAjFA;EA1TE,mBA2T2B;EA1T3B,aA0TgC;EAzThC,gBAyTsC;EAxTtC,aAAA;AA8YF;;AArFA;EACE;IA7TA,sBA8T6B;IA7T7B,aA6TqC;IA5TrC,gBA4T2C;IA3T3C,aAAA;EAsZA;AACF;AAzFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA2FF;;AA1FA;EACE,eAAA;EAtUA,mBAuU2B;EAtU3B,aAsUgC;EArUhC,gBAqUsC;EApUtC,aAAA;EAqUA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAgGF;;AA/FA;EACE;IA/UA,sBAgV6B;IA/U7B,aA+UqC;IA9UrC,gBA8U2C;IA7U3C,aAAA;EAkbA;AACF;AArGA;EAjVE,sBAkV2B;EAjV3B,aAiVmC;EAhVnC,gBAgVyC;EA/UzC,aAAA;EAgVA,eAAA;EACA,sBAAA;AA0GF;;AAxGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;AA2GF;;AA1GA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,wBAAA;AA6GF;;AA5GA;EAtWE,sBAuW2B;EAtW3B,aAsWmC;EArWnC,gBAqWyC;EApWzC,aAAA;EAqWA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAkHF;;AAjHA;EACE,aAAA;AAoHF;;AAlHA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAqHF;AApHE;EACE,cAAA;AAsHJ;;AApHA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AAuHF;;AArHA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AAwHF;;AAtHA;EACE,UAAA;AAyHF;;AAvHA;EACE;IACE,UAAA;EA0HF;AACF;AA1HA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AA4HF;;AA1HA;EACE,uDAAA;EACA,UAAA;AA6HF;;AA5HA;EACE,aAAA;AA+HF;;AA7HA;EACE,WAAA;AAgIF;;AA/HA;EACE,YAAA;AAkIF;;AAjIA;EACE,YAAA;AAoIF;;AAlIA;EA7aE,sBA8a2B;EA7a3B,aA6amC;EA5anC,gBA4ayC;EA3azC,aAAA;EA4aA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAwIF;;AAvIA;EACE;IACE,uBAAA;EA0IF;EAzIA;IACE,kBAAA;EA2IF;AACF;AA3IA;EACE;IACE,uBAAA;EA6IF;AACF;AA5IA;EACE,kBAAA;AA8IF;;AA7IA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAgJF;AA/IE;EACE,YAAA;AAiJJ;;AA/IA;EACE,kBAAA;AAkJF;;AAjJA;;EAEE,UAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,uDAAA;EACA,6BAAA;EACA,oCAAA;AAoJF;;AAlJA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAqJF;;AAnJA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,mHAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;AAsJF;AArJE;EACE,aAAA;EACA,6BAAA;EACA,mHAAA;AAuJJ;;AAtJA;EACE;IACE,YAAA;EAyJF;AACF;AAzJA;EACE;IACE,YAAA;EA2JF;AACF;AA3JA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA6JF;;AA5JA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA+JF;;AA9JA;EACE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAiKF;;AAhKA;EACE;IACE,SAAA;IACA,YAAA;EAmKF;EAlKA;IACE,SAAA;IACA,YAAA;EAoKF;EAnKA;IACE,SAAA;IACA,YAAA;EAqKF;AACF;AArKA;EACE;IACE,SAAA;IACA,YAAA;EAuKF;EAtKA;IACE,SAAA;IACA,YAAA;EAwKF;EAvKA;IACE,SAAA;IACA,YAAA;EAyKF;AACF;AAzKA;EACE;IACE,SAAA;IACA,YAAA;EA2KF;EA1KA;IACE,SAAA;IACA,YAAA;EA4KF;EA3KA;IACE,SAAA;IACA,YAAA;EA6KF;AACF;AA5KA;EACE;IACE,aAAA;EA8KF;EA7KA;IACE,cAAA;EA+KF;AACF;AA7KA;EACE,kCAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AA+KF;;AA7KA;EACE,kCAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAgLF;;AA9KA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAiLF;;AA/KA;EACE;IACE,aAAA;EAkLF;AACF;AAlLA;EACE;IACE,aAAA;EAoLF;AACF;AApLA;EACE,eAAA;AAsLF;;AArLA;EACE,eAAA;EACA,cAAA;EAGA,wCAAA;AAsLF;AAxLE;EACE,YAAA;AA0LJ;;AAvLA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AA0LF;;AAvLA;EACE,mBAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EA1mBA,mBA2mB2B;EA1mB3B,aA0mBgC;EAzmBhC,gBAymBsC;EAxmBtC,aAAA;EAymBA,8BAAA;EACA,kBAAA;AA6LF;;AAzLA;EACE,eAAA;EACA,cAAA;AA4LF;;AA3LA;EACE,cAAA;AA8LF;;AA7LA;EACE;IACE,aAAA;EAgMF;AACF;AA/LA;EACE;IACE,iBAAA;EAiMF;EAhMA;IACE,iBAAA;EAkMF;AACF;AAlMA;EACE;IACE,mBAAA;EAoMF;AACF;AAnMA;EACE;IACE,iBAAA;EAqMF;EApMA;IACE,iBAAA;EAsMF;AACF;AAtMA;EACE;IACE,mBAAA;EAwMF;AACF;AAvMA;EACE,mBAAA;EACA,eAAA;AAyMF","sourcesContent":["@mixin default_container($flex-direction: row, $row_gap, $column_gap)\n  flex-direction: $flex-direction\n  row-gap: $row_gap\n  column-gap: $column_gap\n  display: flex\n\n@import \"slick-carousel/slick/slick.css\"\n@import \"slick-carousel/slick/slick-theme.css\"\n\n.img_logo_mini\n  width: 50px\n  height: 50px\n\n\n.navigation\n  @include default_container(row, 0px, 10px)\n.home_button_img\n  width: 22px\n  height: 19px\n.out_button_img\n  width: 14px\n  height: 22px\n.cancel_button\n  width: 20px\n  height: 20px\n.menu_button\n  display: none\n  z-index: 1003\n  position: relative\n.home_button, .menu_button\n  cursor: pointer\n  border: none\n  background: #222423\n  width: 50px\n  height: 50px\n  border-radius: 16px\n.search_container\n  @include default_container(row, 10px, 10px)\n\n//@media (max-width: 850px)\n//  .search_container\n//    justify-content: space-between\n\n.work_panel_container\n  @include default_container(row, 10px, 10px)\n  position: fixed\n  top: 100px\n  z-index: 20 !important\n  justify-content: space-between\n  width: 100%\n  font-size: 16px\n\n@media (max-width: 850px)\n  .work_panel_container\n    position: static\n\nselect\n  background: #181A19\n  padding: 5px 10px\n  //border-radius: 16px\n  color: white\n  font-size: 16px\n  height: 100%\n  border: none\n  //&:focus\n  //  border-end-end-radius: 0px\n  //  border-end-start-radius: 0px\n  //&:active\n  //  border-end-end-radius: 0px\n  //  border-end-start-radius: 0px\n.input_search\n  padding: 9px 15px\n  border-radius: 16px\n  color: white\n  font-size: 16px\n  text-align: left\n  max-width: 200px\n  background: #181A19\n  border: 2px #373A39 solid\n  &::placeholder\n    text-align: center\n@media (max-width: 850px)\n  .search_container\n    @include default_container(row, 10px, 10px)\n.operation_car_container, .completed_cars_list_container\n  @include default_container(column, 10px, 10px)\n\n\n@media (max-width: 850px)\n  .operation_car_card_container\n    @include default_container(column, 30px, 10px)\n\n@media (max-width: 750px)\n  .search_container\n    @include default_container(column, 10px, 10px)\n\n  .work_panel_container\n    @include default_container(column, 10px, 10px)\n    justify-content: center\n  .input_search\n    max-width: calc(100% - 30px)\n  .sore_container\n    max-width: calc(100% - 30px)\n\n\n.photos_container\n  @include default_container(column, 10px, 10px)\n  position: relative\n  width: 300px\n.photo_car\n  width: 300px\n  height: 300px\n  border-radius: 16px\n  object-fit: cover\n  object-position: center\n.loading\n  opacity: 0.3\n.title_loading\n  position: absolute\n  top: 40%\n  left: 40%\n@media (max-width: 850px)\n\n  .photo_car\n    width: 100%\n    object-fit: cover\n    object-position: center\n  .photos_container\n    position: relative\n    width: 100%\n    padding-top: 50px\n\n\n.operation_car_card_container, .completed_car_card_container\n  background: #222423\n  border-radius: 16px\n  padding: 35px\n  color: white\n  display: grid\n  column-gap: 50px\n  grid-template-columns: 3fr 1fr\n\n.padding\n  padding-bottom: 90px\n@media (max-width: 750px)\n  .information_container\n    grid-template-columns: 1fr !important\n    grid-auto-flow: row\n    grid-template-rows: auto auto auto auto !important\n    grid-template-areas: 'person' 'car' 'status' !important\n@media (max-width: 750px)\n  .information_container\n    align-self: center\n\n@media (max-width: 850px)\n  .completed_car_card_container, .operation_car_card_container\n    display: flex !important\n    flex-direction: column\n@media (max-width: 550px)\n  .information_container_\n    display: flex !important\n    flex-direction: column\n\n\n.information_container, .information_container_\n  @include default_container(column, 30px, 10px)\n\n.information_person_container\n  grid-area: person\n  @include default_container(column, 10px, 10px)\n\n.information_car_container\n  grid-area: car\n  @include default_container(column, 10px, 10px)\n\n.information_car_status_container\n  grid-area: status\n\n\n.line\n  height: 6px\n  background: #373A39\n  border: none\n  position: relative\n  top: -6px\n  left: 0\n\n.line_progress\n  height: 6px\n  position: relative\n  z-index: 3\n  top: 0\n  left: 0\n  border: none\n  background: linear-gradient(to right, #F08319, #E51B2F)\n.status_completed_container\n  border-radius: 16px\n  left: 0\n  border: 2px solid transparent\n  padding: 10px\n  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n\n\n.status_container\n  outline: none\n  position: relative\n  z-index: 3\n  top: 50px\n  border-radius: 16px\n  left: 0\n  border: 2px solid transparent\n  padding: 10px\n  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n@media (max-width: 1100px)\n  .status_container\n    margin-left: 0px !important\n\n.status_completed\n  border-radius: 16px\n  left: 0\n  border: 2px solid transparent\n  padding: 10px\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n.status\n  outline: none\n  position: relative\n  z-index: 3\n  top: -0px\n  border-radius: 16px\n  left: 0\n  border: 2px solid transparent\n  padding: 10px\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n\n.circle\n  top: -31px\n  position: relative\n  background: #373A39\n  width: 15px\n  height: 15px\n  z-index: 3\n  border-radius: 50%\n// Обновляем стили для кружочков\n.circle\n  position: absolute\n  top: 2px // Фиксированная высота для всех кружочков\n  background: #373A39\n  width: 15px\n  height: 15px\n  z-index: 3\n  border-radius: 50%\n  transform: translateX(-50%)\n\n.circle_progress\n  background: linear-gradient(to right, #F08319, #E51B2F) !important\n\n// Контейнер для прогресс-бара\n.information_car_status_container\n  position: relative // Добавляем relative для позиционирования кружочков\n  height: 20px // Фиксированная высота контейнера\n\n.line\n  position: absolute\n  top: 50%\n  transform: translateY(-50%)\n  height: 6px\n  background: #373A39\n  width: 100%\n  border: none\n\n.line_progress\n  position: absolute\n  top: 50%\n  transform: translateY(-50%)\n  height: 6px\n  z-index: 2\n  border: none\n  background: linear-gradient(to right, #F08319, #E51B2F)\n// Убираем старый .circle_progress стиль если он был отдельно\n\n.information_car_completed_status_container\n  @include default_container(row, 10px, 10px)\n  align-items: center\n\n\n.navigation_link\n  color: white\n  text-decoration: none\n\n.whatsapp\n  padding: 1px 3px\n  //width: 26px\n  //height: 26px\n  border-radius: 6px\n  border: none\n  cursor: pointer\n  font-size: 14px\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  color: white\n  transition: all 1s\n  &:hover\n    opacity: 0.5\n\n.info\n  display: flex\n  gap: 10px\n  align-items: center\n@media(max-width: 600px)\n  .info\n    align-self: flex-start\n    //@include default_container(column, 10px, 10px)\n.change_password_container\n  @include default_container(row, 10px, 10px)\n@media(max-width: 730px)\n  .change_password_container\n    @include default_container(column, 10px, 10px)\n@media(max-width: 460px)\n\n.number\n  display: flex\n  align-items: center\n  column-gap: 10px\n.profile_container\n  font-size: 22px\n  @include default_container(row, 10px, 10px)\n  align-items: flex-start\n  justify-content: space-between\n  background: #222423\n  border-radius: 16px\n  padding: 35px\n  color: white\n@media(max-width: 960px)\n  .profile_container\n    @include default_container(column, 10px, 10px)\n.informations_person_container\n  @include default_container(column, 10px, 10px)\n  font-size: 16px\n  align-self: flex-start\n\n.overlay\n  position: fixed\n  top: 0\n  left: 0\n  right: 0\n  bottom: 0\n  background-color: rgba(0, 0, 0, 0.8)\n  z-index: 1004\n.overlay_\n  position: fixed\n  top: 0\n  left: 0\n  right: 0\n  bottom: 0\n  background-color: rgba(0, 0, 0, 0.8)\n  z-index: 1000 !important\n.popup_menu_container\n  @include default_container(column, 10px, 10px)\n  background: #222423\n  position: fixed\n  z-index: 1002\n  right: 50px\n  top: 30px\n  bottom: 30px\n  padding: 80px 10px 10px\n  border-radius: 16px\n.none\n  display: none\n\n.popup_menu_link\n  padding: 5px\n  font-size: 18px\n  text-decoration: none\n  color: #b5b5b5\n  transition: all 1s\n  &:hover\n    color: #ffffff\n\n.grey_popup_menu_link\n  opacity: 0.5\n  padding: 5px\n  font-size: 18px\n  text-decoration: none\n  color: #D9D9D9\n\n.shadow_window_img_container\n  position: fixed\n  top: 50%\n  left: 50%\n  transform: translate(-50%, -50%)\n  width: 80%\n  height: 80%\n  padding: 10px\n  border-radius: 10px\n  z-index: 1005\n  display: flex\n  flex-direction: column\n  align-items: center\n  gap: 10px\n  justify-content: center\n\n.slider\n  width: 65%\n\n@media(max-width: 1000px)\n  .slider\n    width: 85%\n.slick-dots li button\n  display: block\n  width: 15px\n  height: 15px\n  border-radius: 50%\n  background: #D9D9D9\n\n.slick-dots li.slick-active button\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  opacity: 1\nbutton::before\n  display: none\n\n.slick-prev\n  left: -50px\n.slick-next\n  right: -20px\n.save\n  width: 200px\n\n.change_password_window_container\n  @include default_container(column, 20px, 10px)\n  align-items: center\n  background: #222423\n  padding: 70px\n  border-radius: 16px\n@media (max-width: 600px)\n  .change_password_window_container\n    padding: 60px 50px 50px\n  .sort_container\n    padding-top: 120px\n@media (max-width: 450px)\n  .change_password_window_container\n    padding: 60px 30px 30px\n\n.change_input_container\n  position: relative\n.cancel\n  cursor: pointer\n  width: 25px\n  position: absolute\n  right: 15px\n  top: 15px\n  transition: all 1s\n  &:hover\n    opacity: 0.5\n\n.input-container_\n  position: relative\ninput:focus + .placeholder_,\ninput:not(:placeholder-shown) + .placeholder_\n  top: -10px\n  z-index: 2\n  left: 10px\n  font-size: 14px\n  background: #222423\n  background: linear-gradient(to right, #F08319, #E51B2F)\n  -webkit-background-clip: text\n  -webkit-text-fill-color: transparent\n\n.placeholder_\n  position: absolute\n  left: 10px\n  top: 18px\n  transition: all 0.3s ease\n  color: #8E8E8E\n  font-size: 18px\n  pointer-events: none\n  text-align: center\n  width: calc(100% - 20px)\n  background: #222423\n  border-radius: 8px\n\n.change_input\n  padding: 10px 0px\n  text-align: center\n  border-radius: 10px\n  border: 2px solid transparent\n  font-size: 18px\n  height: 30px\n  background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n  width: 600px\n  transition: all 0.3s\n  color: white\n  &:focus\n    outline: none\n    border: 2px solid transparent\n    background: linear-gradient(#ff7979, #222423 0) padding-box, linear-gradient(to right, #F08319, #E51B2F) border-box\n@media (max-width: 800px)\n  .change_input\n    width: 400px\n@media (max-width: 600px)\n  .change_input\n    width: 300px\n.background_new\n  color: #222423\n  z-index: 0\n  position: absolute\n  background: #222423\n  left: 35%\n  top: -12px\n  width: 180px\n.background_new_\n  color: #222423\n  z-index: 0\n  position: absolute\n  background: #222423\n  left: 34%\n  top: -12px\n  width: 190px\n.background_old\n  color: #222423\n  z-index: 0\n  position: absolute\n  background: #222423\n  left: 35%\n  top: -12px\n  width: 180px\n@media (max-width: 800px)\n  .background_old\n    left: 28%\n    width: 178px\n  .background_new\n    left: 29%\n    width: 169px\n  .background_new_\n    left: 27%\n    width: 185px\n@media (max-width: 600px)\n  .background_old\n    left: 21%\n    width: 178px\n  .background_new\n    left: 22%\n    width: 169px\n  .background_new_\n    left: 20%\n    width: 185px\n@media (max-width: 400px)\n  .background_old\n    left: 27%\n    width: 178px\n  .background_new\n    left: 28%\n    width: 169px\n  .background_new_\n    left: 26%\n    width: 185px\n\n@media (max-width: 1100px)\n  .navigation_link, .home_button\n    display: none\n  .menu_button\n    display: block\n\n\n.succeeded\n  background: rgba(97, 200, 98, 0.5)\n  padding: 7px\n  border-radius: 10px\n  font-size: 18px\n\n.error\n  background: rgba(229, 27, 47, 0.5)\n  padding: 7px\n  color: #D9D9D9\n  border-radius: 10px\n  font-size: 18px\n\n.not_found_search\n  color: white\n  display: flex\n  justify-content: center\n  font-size: 20px\n\n@media(min-width: 850px)\n  .input_desktop\n    display: none\n@media(max-width: 850px)\n  .input_mobile\n    display: none\noption\n  font-size: 14px\nselect\n  font-size: 14px\n  color: #F08319\n  &:focus-visible\n    border: none\n  -webkit-tap-highlight-color: transparent\n\nfooter\n  height: 167px\n  background: #181A19\n  display: flex\n  position: fixed\n  bottom: 0\n  left: 0\n  right: 0\n  z-index: 0\n  width: 100%\n\n\nheader\n  background: #181A19\n  position: fixed\n  top: 0\n  z-index: 2\n  height: 50px\n  left: 0\n  right: 0\n  @include default_container(row, 10px, 10px)\n  justify-content: space-between\n  padding: 40px 50px\n//@media(max-width: 600px)\n//  .work_panel_container\n//    padding-top: 120px\n.sort_container\n  font-size: 14px\n  color: #D9D9D9\n.not_visible\n  color: #222423\n@media(max-width: 850px)\n  .not_visible\n    display: none\n\n@media(max-width: 600px)\n  .profile_container\n    margin-top: 140px\n  .operation_work_panel_container\n    margin-top: 140px\n@media(max-width: 750px)\n  .information_container\n    align-self: stretch\n\n@media(max-width: 600px)\n  .profile_container\n    margin-top: 140px\n  .operation_work_panel_container\n    margin-top: 140px\n@media(max-width: 750px)\n  .information_container\n    align-self: stretch\n\ninput:focus\n  transform: scale(1)\n  font-size: 16px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
